module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/take-asset-external/take-asset-external.component.scss
// module id = ./src/app/assessments/take-asset-external/take-asset-external.component.scss
// module chunks = main